<div class="video-modal-container" [innerHTML]="videoUrl"></div>
